import React from 'react';
import { HeroSection } from './components/HeroSection';
import { ProblemSection } from './components/ProblemSection';
import { FailedAttemptsSection } from './components/FailedAttemptsSection';
import { MechanismSection } from './components/MechanismSection';
import { WhatYouGetSection } from './components/WhatYouGetSection';
import { AudienceSection } from './components/AudienceSection';
import { HowItWorksSection } from './components/HowItWorksSection';
import { FinalCTASection } from './components/FinalCTASection';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-dark text-slate-50 font-sans selection:bg-brand-green selection:text-darker" data-id="element-0">
      <HeroSection data-id="element-1" />
      <ProblemSection data-id="element-2" />
      <FailedAttemptsSection data-id="element-3" />
      <MechanismSection data-id="element-4" />
      <WhatYouGetSection data-id="element-5" />
      <AudienceSection data-id="element-6" />
      <HowItWorksSection data-id="element-7" />
      <FinalCTASection data-id="element-8" />
      <Footer data-id="element-9" />
    </div>;
}